
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"13.603","transform":"rotate(-90 8 13.603)","fill":"#B4BCCF","r":"1.6"}}),_c('circle',{attrs:{"cx":"8","cy":"8.002","transform":"rotate(-90 8 8.002)","fill":"#B4BCCF","r":"1.6"}}),_c('circle',{attrs:{"cx":"8","cy":"2.404","transform":"rotate(-90 8 2.404)","fill":"#B4BCCF","r":"1.6"}})])
          )
        }
      }
    